import { format } from 'date-fns';
import connecToQueryHoc, { QueryHocInterface, QueryHocTypes } from 'query-hoc';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { compose } from 'redux';
import { getListTotal, isCommiting } from 'redux-list';
import { useAsyncData } from 'ssr-service';
import { withTheme } from 'styled-components';
import { thunkToAction } from 'typescript-fsa-redux-thunk';
import BasicTable from '../../../components/BasicTable';
import NoItemsFround from '../../../components/NoItemsFound';
import config from '../../../config';
import { RootState } from '../../../configureStore';
import { initializeOrSetListParams } from '../../../containers/App/actions';
import { loadMeEventsList } from '../../../containers/Events/actions';
import { eventsListSelector } from '../../../containers/Events/selectors';
import Loading from '../../../containers/Loading';
import { Event } from '../../../library/Event';
import { ITheme } from '../../../theme/theme';
import __ from '../../../utilities/__';
import { Dot, DotLabel } from '../styledComponents';

const mapDispatchToProps = {
  loadEvents: thunkToAction(loadMeEventsList),
  initializeList: thunkToAction(initializeOrSetListParams.action),
};

const mapStateToProps = (state: RootState) => ({
  events: eventsListSelector(config.ME_EVENTS_LIST_NAME)(state),
  isFetching: isCommiting(config.ME_EVENTS_LIST_NAME)(state),
  total: getListTotal(config.ME_EVENTS_LIST_NAME)(state),
});

const MeEvents: React.FC<
  typeof mapDispatchToProps &
    QueryHocInterface &
    RouteComponentProps<{}, {}> &
    ReturnType<typeof mapStateToProps> & { theme: ITheme }
> = ({
  theme,
  loadEvents,
  initializeList,
  query,
  events,
  isFetching,
  total,
  setParameter,
  router: { push },
}) => {
  useAsyncData(async () => {
    await initializeList({
      listName: config.ME_EVENTS_LIST_NAME,
      params: query,
    });
    await loadEvents();
  }, [query]);

  const getStatus = (i: Event) => {
    let label = '';
    let color = '';
    if (i.played && !i.closed) {
      label = __('Zatiaľ neodohrané');
      color = theme.color.fadedText;
    } else if (i.played && i.closed) {
      label = __('Odohrané');
      color = theme.color.success;
    } else if (i.invited) {
      label = __('Nová pozvánka');
      color = theme.color.warning;
    }
    return (
      <DotLabel>
        <Dot color={color} />
        <div style={{ fontWeight: 200, color }}>{label}</div>
      </DotLabel>
    );
  };

  return (
    <>
      {isFetching ? (
        <Loading />
      ) : (
        <>
          {events.length > 0 ? (
            <>
              <BasicTable
                renderRow={i => [
                  getStatus(i),
                  format(i.startDate, 'DD.MM.YYYY'),
                  i.sportGround.name,
                ]}
                colsCount={3}
                onClickRow={i => {
                  push(`/admin/event/${i._id}`);
                }}
                rowKey="_id"
                columns={[
                  { header: __('Stav') },
                  { header: __('Dátum') },
                  { header: __('Miesto') },
                ]}
                rows={events}
                withPaginator
                offset={Number(query.offset)}
                limit={config.DEFAULT_LIST_LIMIT}
                total={total || 0}
                onChangeOffset={newOffset => {
                  setParameter({ offset: newOffset });
                }}
              />
            </>
          ) : (
            <NoItemsFround label={__('Nenašli sa žiadne zápasy')} />
          )}
        </>
      )}
    </>
  );
};

export default compose(
  connecToQueryHoc({
    parameters: { offset: { type: QueryHocTypes.Number, defaultValue: 0 } },
  }),
  withTheme,
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(MeEvents);
